(function () {
  'use strict';
  if (window.albTrendfulLoader) return;
  window.albTrendfulLoader = true;

  var origin = 'https://atlanta-luxury-bags.trendful.com';
  var selector = '.trendful-button, #trendful-button';
  var loading;
  var ready = false;
  var pendingButton;
  var pageLoaded = new Promise(function (resolve) {
    if (document.readyState === 'complete') resolve();
    else window.addEventListener('load', resolve, { once: true });
  });

  function load() {
    if (loading) return loading;
    // Supply the public bootstrap token so the vendor skips its synchronous lookup.
    loading = pageLoaded.then(async function () {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
      var token;
      try {
        var response = await fetch('https://api.trendful.com/merchant_settings', {
          headers: { 'X-Trendful-Host': new URL(origin).host },
          credentials: 'omit',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Trendful settings unavailable');
        var settings = await response.json();
        token = typeof settings.merchant_token === 'string' && settings.merchant_token.trim();
        if (!token) throw new Error('Trendful merchant unavailable');
      } finally {
        window.clearTimeout(timeout);
      }
      await new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.setAttribute('trendful', '');
        script.src = origin + '/init.js?token=' + encodeURIComponent(token);
        script.async = true;
        script.onload = function () {
          if (document.getElementById('trendful-iframe')) resolve();
          else reject(new Error('Trendful did not initialize'));
        };
        script.onerror = function () {
          script.remove();
          reject(new Error('Trendful script unavailable'));
        };
        document.body.appendChild(script);
      });
      ready = true;
    });
    return loading;
  }

  function showFallback() {
    if (document.getElementById('alb-trendful-fallback')) return;
    var notice = document.createElement('p');
    notice.id = 'alb-trendful-fallback';
    notice.setAttribute('role', 'alert');
    notice.appendChild(document.createTextNode('The quote form could not open. '));
    var link = document.createElement('a');
    link.href = origin + '/' + window.location.search;
    link.textContent = 'Continue on our secure quote page';
    notice.appendChild(link);
    if (pendingButton) pendingButton.insertAdjacentElement('afterend', notice);
    else (document.querySelector('[data-trendful-inline="app"]') || document.body).appendChild(notice);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(selector);
    if (!button) return;
    // Suppress placeholder href navigation, including once the vendor is ready.
    event.preventDefault();
    if (ready) {
      // The vendor checks the target class, so normalize clicks on nested icons/text.
      if (event.target !== button) {
        event.stopImmediatePropagation();
        button.click();
      }
      return;
    }
    event.stopImmediatePropagation();
    if (pendingButton) return;
    pendingButton = button;
    button.setAttribute('aria-busy', 'true');
    load().then(function () {
      button.removeAttribute('aria-busy');
      pendingButton = null;
      button.click();
    }).catch(function () {
      button.removeAttribute('aria-busy');
      showFallback();
      pendingButton = null;
    });
  }, true);

  function bootstrapRequiredFlow() {
    var params = new URLSearchParams(window.location.search);
    var autoOpen = ['sell-my-item-now', 'sell-your-item-now', 'trendful_reset', 'reset_token', 'trendful_verify']
      .some(function (key) { return params.has(key); });
    if (autoOpen || document.querySelector('[data-trendful-inline="app"]')) load().catch(showFallback);
  }
  bootstrapRequiredFlow();
  document.addEventListener('shopify:section:load', bootstrapRequiredFlow);
})();
